// NOTE: components
import Skeleton from '../../components/ui/Skeleton'

// NOTE: the content type is only known once the query resolves, so the body mirrors the parts every type renders
const BODY_PLACEHOLDERS = [
	{ id: 'first', className: 'w-full' },
	{ id: 'second', className: 'w-full' },
	{ id: 'third', className: 'w-11/12' },
	{ id: 'fourth', className: 'w-3/4' }
]

const ContentSkeleton = () => (
	<div role="status" aria-label="Loading content">
		<section className="bg-white">
			<div className="mx-auto w-full max-w-7xl px-5 pt-20 sm:px-8 sm:py-10">
				{/* Go back */}
				<Skeleton className="mb-8 h-7 w-[110px]" />

				{/* Title */}
				<Skeleton className="mb-4 h-10 w-full max-w-[680px] sm:h-12 md:h-[60px]" />

				{/* Dek */}
				<div className="mb-8 max-w-[52ch]">
					<Skeleton className="mb-2.5 h-6 w-full md:h-7" />
					<Skeleton className="h-6 w-3/4 md:h-7" />
				</div>

				{/* Cover, PDF or player */}
				<Skeleton className="mb-8 h-[70vh] max-h-[500px] min-h-[300px] w-full rounded-lg" />

				{/* Body */}
				<div>
					{BODY_PLACEHOLDERS.map(({ id, className }) => (
						<Skeleton key={id} className={`mb-3 h-5 ${className}`} />
					))}
				</div>
			</div>
		</section>
	</div>
)

export default ContentSkeleton
